import React, { useState, useEffect, useRef } from "react";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import useTableFijo from "../useTableFijo";
import axios from "axios";
import { Toasts } from "../toasts";
import moment from "moment";
import { formatMoneda, validaSoloNumero } from "../../util/varios";
import ModalAgregarAvaluo from "./modalAgregarAvaluo";
import TablaDeudaInmueble from "../hacienda/inmueblesUrbanos/tablaDeudaInmueble";
import TablaHistoricosInmuebles from "../hacienda/inmueblesUrbanos/tablaHistoricoInmuebe";
import useTableFijo2 from "../useTableFijo2";
import ModalAgregarFactura from "./incluirFactura";
import CatalogoInmueble from "../../catalogos/catalogoInmueble";
import CatalogoValorFisCon from "../../catalogos/catalogoValorFisConst";
import TablaLayout from "../comun/Tabla/TablaLayout";
import { Input, Radio, SearchInput, Select, Textarea } from "../../ui/inputs/Input";
import { DangerButton, InfoButton, PrimaryButton, WarningButton } from "../../ui/buttons/Button";

function TablaAvaluos(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");
  let periodo, numpago;
  let montPagar;
  const permiso = JSON.parse(localStorage.getItem('accavaluo')) === null ? "0000" : JSON.parse(localStorage.getItem('accavaluo')).trim();
  const [idUsuario] = useState(localStorage.getItem("idusuario"));
  const [ip] = useState(localStorage.getItem("ip"));
  const [mac] = useState(localStorage.getItem("mc"));
  const txtCodInmueble = useRef();
  const txtNomPro = useRef();
  const txtCodCat = useRef();
  const txtDireccion = useRef();
  const radioExonerado1 = useRef();
  const radioExonerado2 = useRef();
  const txtmontoavaluo = useRef();
  const txtannoDeuda = useRef();
  const txtCodActividad = useRef();
  const txtCodigoCiu = useRef();
  const txtAnios = useRef();
  const txtDescripcionActi = useRef();
  const txtAlicuota = useRef();
  const txtIdComercio = useRef();
  const txtNumPatente = useRef();
  const txtvaloruniconst = useRef();
  const txtRitm = useRef();
  const cmbdesde = useRef();
  const cmbhasta = useRef();
  const txtmontoanual = useRef();
  const txtmontomensual = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [espiritu] = useState(localStorage.getItem("espiritu"));
  const [activo, setActivo] = useState(true);
  const [activo2, setActivo2] = useState(true);
  const [activo3, setActivo3] = useState(true);
  const [activo4, setActivo4] = useState(true);
  const [operacionFact, setOperacionFact] = useState(true);

  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [numfac, setNumfac] = useState();
  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrarFact, setMostrarFact] = useState(false);
  const [idInmueble, setIdinmueble] = useState('')
  const [credito, setCredito] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [valorFisCons, setValorFisCons] = useState();
  const [totalAvaluo, setTotalAvaluo] = useState(0.0);
  const [anioActu] = useState(localStorage.getItem("anioactu"));
  const [operacion, setOperacion] = useState();
  const [id, setId] = useState();
  const [valorPorcentual, setValorPorcentual] = useState(1000.0);
  const [idinmu, setIdinmu] = useState();
  const [idavaluo, setIdavaluo] = useState();
  const [factorCambio, setFactorCambio] = useState(0);
  const [records, setRecords] = useState([]);
  const [records2, setRecords2] = useState([]);
  const [avaluoc, setAvaluoc] = useState();
  const [montoAvaluo, setMontoAvaluo] = useState(0);
  const [descuento, setDescuento] = useState(0.0);
  const [inmueble, setInmueble] = useState();
  const [itemSelect, setItemSelect] = useState(-1);
  const [itemSelect2, setItemSelect2] = useState(-1);
  const [mostrarValor, setMostrarValor] = useState(false);
  const [deshabilitado] = useState(false);
  const [Avaluo] = useState(0.0);
  const [anio, setAnio] = useState([]);
  const [configInmueble, setConfigInmueble] = useState();
  const [np, setNp] = useState(0);
  const [prd, setPrd] = useState(0);
  const [valorPetro, setValorPetro] = useState();
  const [idClaseTerr, setIdClaseTerr] = useState();
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const btnRegistro = useRef();


  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells2 = [
    {
      id: "1",
      label: "N° FACTURA",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "2",
      label: "MONTO",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA DEL AVALÚO",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AÑO",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AREA PRIV. M2",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AREA MUNIC M2",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AREA CONSTRUC. M2",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR TERRE. TCMMV",
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR CONSTRUC. TCMMV",
      textAlign: "center",
    },
    {
      id: "9",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO TOTAL AVALÚO TCMMV",
      textAlign: "center",
    },
  ];

  const { TblContainer, TblHead } = useTableFijo(records, headCells, filterFn);

  const { TblContainer2, TblHead2 } = useTableFijo2(
    records2,
    headCells2,
    filterFn,
    320
  );

  const seleccionarValorPetro = () => {
    let endpoint = op.conexion + "/api/efiscal/valorpetro";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValorPetro(response.data.valor);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const selectCargarDeuda = () => {
    let monto = txtmontomensual.current.value
      .replace(/\./g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    let monto2 = parseFloat(monto) / parseFloat(factorCambio);
    let endpoint = `${op.conexion}/api/inmueble/creardeudainmueble`;

    let body;
    body = {
      txtcodigo: parseInt(
        inmueble
          ? inmueble.idinmueble !== null
            ? inmueble.idinmueble.trim()
            : ""
          : ""
      ),
      cmbdesde: parseInt(cmbdesde.current.value),
      cmbhasta: parseInt(cmbhasta.current.value),
      txtvaloruniconst: valorFisCons ? parseFloat(valorFisCons.porcentajeconstruc) : 1,
      txtvalorporce: parseFloat(
        configInmueble.valorporcentual === 1 ? 100.0 : 1000.0
      ),
      txtmontoavaluo: parseFloat(
        txtmontoavaluo.current.value.replace(/\./g, "").replace(",", ".")
      ),
      txtmontomensual: parseFloat(monto2),

      txtvalorpetro: parseFloat(factorCambio),
      txtperiodo: parseInt(prd),
      txtnumpago: parseInt(np),

      txtidusua: JSON.parse(idUsuario),

      txtanioact: parseInt(anioActu),
      txtfechasis: fechaSistema,
      txtip: JSON.parse(ip),
      txtmac: JSON.parse(mac),
    };

    console.log(body)
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Deuda Cargada",
            icono: "exito",
          });
          //blanquear();
          datosContribuyente(idInmueble, 13)
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const crearDeuda = () => {
    let sigue = true;
    if (txtannoDeuda.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "No se puede Cargar la Deuda Seleccione un año",
        icono: "informacion",
      });

      txtannoDeuda.current.focus();
      sigue = false;
    } else if (cmbdesde.current.value === "" || cmbhasta.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La Fecha de Inicio y Final no pueden estar vacia",
        icono: "informacion",
      });

      sigue = false;
      cmbdesde.current.focus();
    } else if (cmbdesde.current.value > cmbhasta.current.value) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La Fecha de Inicio no puede ser Mayor a la Fecha Final",
        icono: "informacion",
      });

      sigue = false;
    } else if (sigue) {
      selectCargarDeuda();
    }
  };

  const SelectDeudaC = (data) => {
    let endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${data.idinmueble}&fecha=${fechaSistema}&espiritu=${espiritu}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                multa: response.data[i].multa,
                recargo: response.data[i].recargodeu,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarUso = (data) => {
    let campos = "*";
    let nomtab = "valorfiscalxusoterreno";
    let nomid = "usoterreno";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.usoconstruccion}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
        }
        seleccionaAvaluos(data);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarDeclaWeb = () => {
    let campos = "*";
    let nomtab = "configindustria";
    let orden = "1";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarConfigInmueble = () => {
    let campos = "*";
    let nomtab = "configinmueble";
    let orden = "1";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200 && response.data.length > 0) {
          setConfigInmueble(response.data[0]);
          if (response.data === "") {
            setValorPorcentual(1000.0);
          } else {
            setValorPorcentual(
              response.data.valorporcentual !== null
                ? response.data.valorporcentual === 1
                  ? 100.0
                  : 1000.0
                : 0.0
            );
          }
          switch (parseInt(response.data[0].periodopago)) {
            case 1:
              periodo = 12;
              numpago = 1;
              setNp(numpago);
              setPrd(periodo);
              break;
            case 2:
              periodo = 3;
              numpago = 4;
              setNp(numpago);
              setPrd(periodo);
              break;
            case 3:
              periodo = 1;
              numpago = 12;
              setNp(numpago);
              setPrd(periodo);
              break;
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setConfigInmueble(null);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idinmueble) => {
    // let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data !== "") {
            setIdinmu(response.data);
            setCredito(response.data.credito);
            SelectDeudaC(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setIdavaluo(records[index].idavaluo);
    setActivo(false);
  };

  const seleccionarFila2 = (index) => (event) => {
    setItemSelect2(index);
    setNumfac(records2[index].numerofactura);
    setActivo2(false);
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const seleccionaAvaluos = (data) => {
    setItemSelect(-1);
    let campos = "*";
    let nomtab = "avaluo";
    let condi = "idinmueble=" + data.idinmueble;
    let orden = "fechaavaluo desc";

    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        seleccionarAvaluo(data);
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarAvaluo = (data) => {
    let endpoint = `${op.conexion}/api/inmueble/avaluo?idinmueble=${data.idinmueble}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setAvaluoc(response.data);
        }
        seleccionarValorConstruccion(data);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const calcularAV = () => {
    let porcentaje = 0.0;
    let procedentdepre = 0.0;
    let valoraval = 0.0;
    let valorTotal = 0.0;

    procedentdepre = parseFloat(descuento);
    valoraval = parseFloat(montoAvaluo);

    porcentaje =
      (parseFloat(valoraval) / valorPorcentual) * parseFloat(procedentdepre);

    valorTotal = parseFloat(valoraval) - parseFloat(porcentaje);

    setTotalAvaluo(valorTotal);

    if (radioExonerado1.current.checked) {
    } else if (radioExonerado2.current.checked) {
      let porcen = 0.0;
      let porcen2 = 0.0;
      let montMes = 0.0;

      porcen = parseFloat(valorFisCons.porcentajeconstruc * factorCambio);
      porcen2 = porcen / valorPorcentual;
      montPagar = porcen2 * valorTotal;

      montMes = montPagar / np;
    }
  };

  const seleccionarValorConstruccion = (data) => {
    let campos = "*";
    let nomtab = "valorfiscconstruc";
    let nomid = "idvalorfiscconstruc";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idvalorfiscalconstruccion}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setValorFisCons(response.data);
          SelectDeudaC(data);
        }
      })
      .catch((error) => {
        SelectDeudaC(data);
        setActivate(false);
      });
  };

  const facturasCredito = (data) => {
    let endpoint = `${op.conexion}/api/catastro/facturascredito?idinmueble=${data.idinmueble}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setRecords2(response.data);
          }
        }
        seleccionarUso(data);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const datosContribuyente = (id, tecla) => {
    let campos =
      "credito,idtipoinmueble,idclaseinmueble,idclaseterreno,idvalorfiscalconstruccion,valorconstruccion,valorterreno,exonerado,idinmueble,trim(nombrepropie) as nombrepropie, trim(parroquia) as parroquia, trim(urbocupante) as urbocupante, trim(nomurbocupante) as nomurbocupante, trim(dirpropie2) as dirpropie2, trim(descridirpropie2) as descridirpropie2, trim(dirpropie3) as dirpropie3, trim(descridirpropie3) as descridirpropie3, trim(usoterreno) as usoterreno, trim(numcivicopropie) as numcivicopropie, TRIM(dirpropie4) as dirpropie4, trim(descridirpropie4) as descridirpropie4 ,codigocatastral, trim(usoconstruccion) as usoconstruccion";

    let nomtab = "inmueble";
    let nomid = "idinmueble";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    setIdinmueble(id)
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setActivo3(false);
            setActivo4(false);
            setOperacion(2);
            setId(response.data.idinmueble);
            txtCodInmueble.current.value = response.data.idinmueble;
            txtDireccion.current.value =
              response.data.parroquia +
              ", " +
              response.data.urbocupante +
              " " +
              response.data.nomurbocupante +
              " " +
              response.data.dirpropie2 +
              " " +
              response.data.dirpropie2 +
              " " +
              response.data.descridirpropie2 +
              " ENTRE " +
              response.data.dirpropie3 +
              " " +
              response.data.descridirpropie3 +
              " Y " +
              response.data.dirpropie4 +
              " " +
              response.data.descridirpropie4 +
              " LOCAL " +
              response.data.usoterreno +
              " " +
              response.data.numcivicopropie;
            txtCodCat.current.value = maskIt(
              "00-00-00-0-00-000-000-000-000-000-000",
              response.data.codigocatastral
            );
            txtNomPro.current.value = response.data.nombrepropie;
            setCredito(response.data.credito);
            setIdClaseTerr(response.data.idclaseterreno);
            let des =
              ((response.data.valorterreno
                ? response.data.valorterreno.toString()
                : 0) +
                (response.data.valorconstruccion
                  ? response.data.valorconstruccion.toString()
                  : 0) /
                100) *
              parseFloat(descuento);

            setTotalAvaluo(
              (response.data.valorterreno
                ? response.data.valorterreno.toString()
                : 0) +
              (response.data.valorconstruccion
                ? response.data.valorconstruccion.toString()
                : 0) -
              des
            );
            setInmueble(response.data);
            setIdinmu(response.data.idinmueble);
            setMontoAvaluo(
              parseFloat(
                response.data.valorconstruccion
                  ? response.data.valorconstruccion.toString()
                  : 0
              ) +
              parseFloat(
                response.data.valorterreno
                  ? response.data.valorterreno.toString()
                  : 0
              )
            );
            txtmontoanual.current.value = "";
            txtmontomensual.current.value = "";

            setActivate(false);
            facturasCredito(response.data);
            if (tecla === 13){
              btnRegistro.current.focus();
            }
          } else {
            txtCodInmueble.current.value = "";
            txtDireccion.current.value = "";
            txtCodCat.current.value = "";
            txtNomPro.current.value = "";
            setRecords([]);
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe el contribuyente.', icono: 'informacion' });
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const catalogoAceptar = (idInmue) => {
    setMostrar2(false);
    datosContribuyente(idInmue, 13);
  };
  const validarClasificador = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosContribuyente(event.target.value, event.which);
      } else {
        txtCodInmueble.current.value = "";
        txtDireccion.current.value = "";
        txtCodCat.current.value = "";
        txtNomPro.current.value = "";
        setTotalAvaluo("0,00");
        setRecords();
        setDeuda();
        setInmueble();
        setHistorico();
        setActivo3(true);
      }
    }
  };

  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = "";
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === "0") {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }

  const registroPublico = (op) => (e) => {
    setOperacion(op);
    if (op === 2 || op === 3) {
      for (let i = 0; i < records.length; i++) {
        if (records[i].idavaluo === idavaluo) {
          records.splice(i, 1);
          i--;
        }
      }
      setRecords([...records]);
    }
    setMostrar(true);
  };

  const onChange = (event) => {
    if (event.target.name === "idavaluo") {
      const selectedIndex = event.target.options.selectedIndex;
      let monto = event.target.options[selectedIndex].getAttribute("data-key");
      setMontoAvaluo(parseFloat(monto));
    }
  };

  useEffect(() => {
    seleccionarConfigInmueble();
    seleccionarValorPetro();
    seleccionarDeclaWeb();
    seleccionarFactorCambio();
    let anioact = JSON.parse(localStorage.getItem("efiscalanio"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
  }, []);

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "inputAnio") {
          txtDescripcionActi.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const gestionarFact = (op) => (e) => {
    e.preventDefault();
    setOperacionFact(op);
    setMostrarFact(true);
  };

  const updateValor = (values) => {
    setMostrarValor(false);
    setValorFisCons(values);
    txtIdComercio.current.value = values.idvalorfiscconstruc;
    txtNumPatente.current.value = values.descripcion;

    let montoaval = txtRitm.current.value
      .replace(/\./g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    let uc = factorCambio;
    let ucaval = parseFloat(montoaval) * parseFloat(uc);
    let porce = parseFloat(values.porcentajeconstruc) / 100;
    let totalAnual = parseFloat(ucaval) * parseFloat(porce);
    let totalMes = totalAnual / 4;
    txtmontoanual.current.value = formatMoneda(
      totalAnual.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtmontomensual.current.value = formatMoneda(
      totalMes.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );

    let porcentaje = 0.0;
    let procedentdepre = 0.0;
    let valoraval = 0.0;
    let valorTotal = 0.0;

    procedentdepre = parseFloat(descuento);
    valoraval = parseFloat(Avaluo);

    porcentaje =
      (parseFloat(valoraval) / valorPorcentual) * parseFloat(procedentdepre);

    valorTotal = parseFloat(valoraval) - parseFloat(porcentaje);

    setTotalAvaluo(montoaval);

    if (radioExonerado1.current.checked) {
    } else if (radioExonerado2.current.checked) {
      let porcen = 0.0;
      let porcen2 = 0.0;
      let montMes = 0.0;

      porcen = parseFloat(values.porcentajeconstruc * valorPetro);
      porcen2 = porcen / valorPorcentual;
      montPagar = porcen2 * valorTotal;
    }
  };
  const onKeyUpInm = (idinmueble) => {
    let campos = "*";
    let nomtab = "valorfiscconstruc";
    let nomid = "idvalorfiscconstruc";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtIdComercio.current.value = response.data.idvalorfiscconstruc;
            txtNumPatente.current.value = response.data.descripcion;
            setActivate(false);
            setValorFisCons(response.data);
            if (radioExonerado1.current.checked) {
              0.0;
            } else if (radioExonerado2.current.checked) {
              let montoaval = txtRitm.current.value
                .replace(/\./g, "")
                .replace(/\./g, "")
                .replace(",", ".");
              let uc = factorCambio;
              let ucaval = parseFloat(montoaval) * parseFloat(uc);
              let porce = parseFloat(response.data.porcentajeconstruc) / 100;
              let totalAnual = parseFloat(ucaval) * parseFloat(porce);
              let totalMes = totalAnual / 4;
              txtmontoanual.current.value = formatMoneda(
                totalAnual.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
              txtmontomensual.current.value = formatMoneda(
                totalMes.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
            }
          } else {
            txtIdComercio.current.value = "";
            txtNumPatente.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Valor Fiscal no existe.",
              icono: "error",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarValor = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        onKeyUpInm(event.target.value);
      } else {
        txtIdComercio.current.value = "";
        txtNumPatente.current.value = "";
      }
    }
  };
  const blanquear = () => {
    setIdinmueble()
    txtCodInmueble.current.value = "";
    txtCodCat.current.value = "";
    txtNomPro.current.value = "";
    txtDireccion.current.value = "";
    setInmueble();
    setRecords();
    txtmontoavaluo.current.value = "";
    txtIdComercio.current.value = "";
    setOperacion(1);
    setValorFisCons();
    setTotalAvaluo("");
    txtRitm.current.value = "";
    txtmontoanual.current.value = "";
    txtmontomensual.current.value = "";
    txtNumPatente.current.value = "";
  };
  const cerrar = () => {
    props.setTabla(0);
  };

  console.log(factorCambio)
 
  return (
    <div className="col-8 m-0 p-2 rounded d-flex flex-column justify-content-center" 
     style={{ minHeight: '80vh' }}>
    <div className="col-12 m-0 p-2 border rounded"  >
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Gestion de registro de avaluos</h3>
        <a type="button" className="text-light fw-bold fs-6" onClick={() => cerrar()}>
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex flex-wrap justify-content-between">
        <div className="col-6 m-0 p-0">
          <SearchInput label='Código de Contribuyente:'
            ref={txtCodInmueble}
            onKeyUp={validarClasificador}
            onBlur={validarClasificador}
						onChange={() => {
							txtDireccion.current.value = "";
              txtCodCat.current.value = "";
              txtNomPro.current.value = "";
              setTotalAvaluo("0,00");
              setRecords();
              setDeuda();
              setInmueble();
              setHistorico();
              setActivo3(true);
              setActivo(true);
              setActivo4(true);
						}}
            onClickButton={() => { setMostrar2(true) }}
          />
        </div>
        <div className="col-4 col-lg-3 m-0 p-0 d-flex gap-2 justify-content-end">
          <span className="fw-bold">
            Valor Euro €:
          </span>
          {formatMoneda(
            factorCambio.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          )}
        </div>
      </div>
      <div className="col-12 m-0 mb-1 p-0 d-flex flex-wrap">
        <div className="col-12 col-lg-4 m-0 p-0">
          <Input label='Código Catastral:'
            disabled
            ref={txtCodCat}
          />
        </div>
        <div className="col-12 col-lg-8 m-0 p-0 pl-2">
          <Input label='Nombre del Propietario:'
            ref={txtNomPro}
            disabled
          />
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <Textarea label='Dirección del Inmueble:'
          style={{ height: 70 }}
          disabled
          ref={txtDireccion}
        />
      </div>
      {/* TABS */}
      <ul
        className="col-md-12 m-auto d-flex flex-nowrap align-items-center nav nav-pills"
        id="myTab"
        role="tablist"
       
      >
        <li className="nav-item mx-auto flex-shrink-0" role="presentation">
          <button
            className="nav-link active"
            id="registro-tab"
            data-bs-toggle="tab"
            data-bs-target="#registro-tab-pane"
            type="button"
            role="tab"
            aria-controls="registro-tab-pane"
            aria-selected="true"
            disabled={activo3}
            ref={btnRegistro}
          >
            <i className="fas fa-user-edit me-2"></i>
            Registro de Avalúos
          </button>
        </li>
        <li className="nav-item mx-auto flex-shrink-0" role="presentation">
          <button
            className="nav-link"
            id="datos-tab"
            data-bs-toggle="tab"
            data-bs-target="#datos-tab-pane"
            type="button"
            role="tab"
            aria-controls="datos-tab-pane"
            aria-selected="false"
            disabled={activo3}
          >
            <i className="fas fa-vote-yea me-2"></i>
            Datos Tributarios
          </button>
        </li>
        <li className="nav-item mx-auto flex-shrink-0" role="presentation">
          <button
            className="nav-link"
            id="deuda-tab"
            data-bs-toggle="tab"
            data-bs-target="#deuda-tab-pane"
            type="button"
            role="tab"
            aria-controls="deuda-tab-pane"
            aria-selected="false"
            disabled={activo3}
          >
            <i className="fas fa-vote-yea me-2"></i>
            Deuda del Contribuyente
          </button>
        </li>
        <li className="nav-item mx-auto flex-shrink-0">
          <button
            className="nav-link"
            id="historico-tab"
            data-bs-toggle="tab"
            data-bs-target="#historico-tab-pane"
            type="button"
            role="tab"
            aria-controls="historico-tab-pane"
            aria-selected="false"
            disabled={activo3}
          >
            <i className="fas fa-vote-yea me-2"></i>
            Historico
          </button>
        </li>
      </ul>
      <div className="tab-content p-0" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="registro-tab-pane"
          role="tabpanel"
          aria-labelledby="registro-tab"
          tabindex="0"
        >
          <div className="col-12 m-0 p-0 d-flex">
            <div className="col-11 m-0 p-0">
              <TblContainer
                container={{
                  height: 200,
                  width: "100%",
                  overflow: "auto",
                  padding: "2px",
                }}
              >
                <TblHead />
                <tbody>
                  {records &&
                    records.map((item, index) => (
                      <tr
                        disabled={operacion === 4 ? true : false}
                        style={{
                          padding: "0",
                          cursor: "pointer",
                          background:
                            itemSelect === index ? "lightskyblue" : "white",
                        }}
                        onClick={seleccionarFila(index)}
                      >
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {item.idavaluo}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {moment.utc(item.fechaavaluo).format("DD-MM-YYYY")}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {moment.utc(item.fechaavaluo).format("YYYY")}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "right" }}>
                          {formatMoneda(
                            item.areaterreno.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "right" }}>
                          {formatMoneda(
                            item.areamunicipal.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "right" }}>
                          {formatMoneda(
                            item.areaconstruccion
                              .toString()
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "right" }}>
                          {formatMoneda(
                            item.valorterreno.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "right" }}>
                          {formatMoneda(
                            item.valorconstruccion
                              .toString()
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "right" }}>
                          {formatMoneda(
                            (
                              parseFloat(item.valorterreno) +
                              parseFloat(item.valorconstruccion)
                            )
                              .toString()
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
              {/*<TblPagination />*/}
            </div>
            <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
              <div className="col-auto m-0 p-0">
                <PrimaryButton icon='fa-plus m-0'
                  onClick={registroPublico(1)}
                  disabled={permiso.toString().substring(1, 2) === "0" ? true : activo4}
                />
              </div>
              <div className="col-auto m-0 p-0">
                <InfoButton icon='fa-eye m-0'
                  type="button"
                  onClick={registroPublico(4)}
                  disabled={permiso.toString().substring(0, 1) === "0" ? true : activo}
                />
              </div>
              <div className="col-auto m-0 p-0">
                <WarningButton icon='fa-edit m-0'
                  onClick={registroPublico(2)}
                  disabled={permiso.toString().substring(2, 3) === "0" ? true : activo}
                />
              </div>
              <div className="col-auto m-0 p-0">
                <DangerButton icon='fa-trash-alt m-0'
                  onClick={registroPublico(3)}
                  disabled={permiso.toString().substring(3, 4) === "0" ? true : activo}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade "
          id="datos-tab-pane"
          role="tabpanel"
          aria-labelledby="datos-tab"
          tabindex="0"
        >
          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center border-azul rounded">
            <legend className="float-none w-auto m-0">
              Datos Físcales
            </legend>
            <div className="col-4 m-0 p-0 d-flex gap-2">
              <span className="fw-bold m-0">Exonerado:</span>
              <div className="col-auto m-0 p-0">
                <Radio label='Si'
                  disabled
                  ref={radioExonerado1}
                  name="exonerado"
                  id="radio1"
                  value={
                    inmueble
                      ? inmueble.exonerado !== null
                        ? inmueble.exonerado
                        : 1
                      : 1
                  }
                  defaultChecked={inmueble && inmueble.exonerado === 1}
                />
              </div>
              <div className="col-auto m-0 p-0">
                <Radio label='No'
                  disabled
                  ref={radioExonerado2}
                  name="exonerado"
                  id="radio2"
                  value={
                    inmueble
                      ? inmueble.exonerado !== null
                        ? inmueble.exonerado
                        : 0
                      : 0
                  }
                  defaultChecked={inmueble && inmueble.exonerado === 0}
                />
              </div>
            </div>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">Avaluos</legend>
              <div className="col-md-2 m-0 mb-1 ">
                <Select label='Año:'
                  disabled={inmueble && inmueble.idinmueble ? false : true}
                  name="idavaluo"
                  onChange={onChange}
                  ref={txtannoDeuda}
                  id="inputFechaReg"
                >
                  <option value="">Seleccionar</option>
                  {avaluoc &&
                    avaluoc.map((item, index) => (
                      <option
                        key={index}
                        data-key={
                          parseFloat(item.valorconstruccion) +
                          parseFloat(item.valorterreno)
                        }
                        value={item.idavaluo}
                        onClick={calcularAV}
                      >
                        {" "}
                        {item.fechaavaluo.substring(0, 4)}{" "}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-md-3 m-0 mb-1 p-0 px-2">
                <Input label='% Descuento:'
                  inputClassName="text-end"
                  disabled
                  id="inputProcedente"
                  defaultValue={0.0}
                  value={formatMoneda(
                    descuento.toString().replace(".", ","),
                    ",",
                    ".",
                    2
                  )}
                  onChange={(event) => setDescuento(event.target.value)}
                  onKeyUp={calcularAV}
                  onBlur={calcularAV}
                />
              </div>
              <div className="col-md-3 m-0 mb-1 p-0 px-2 ">
                <Input label='Monto Avaluo:'
                  inputClassName="text-end"
                  disabled={true}
                  ref={txtmontoavaluo}
                  value={formatMoneda(
                    Avaluo.toString().replace(".", ","),
                    ",",
                    ".",
                    2
                  )}
                  id="inputDenoComer"
                  onKeyUp={handleInputChange}
                />
              </div>
              <div className="col-md-3 m-0 mb-1 p-0 px-2 ">
                <Input label='Total Avaluo:'
                  inputClassName="text-end"
                  disabled={true}
                  ref={txtmontoavaluo}
                  value={formatMoneda(
                    totalAvaluo.toString().replace(".", ","),
                    ",",
                    ".",
                    2
                  )}
                  id="inputDenoComer"
                  onKeyUp={handleInputChange}
                />
              </div>
              <div className="col-3 m-0 mb-1 p-0 px-2">
                <SearchInput label='Id Valor Contruc-c.'
                  ref={txtIdComercio}
                  disabled={inmueble && inmueble.idinmueble ? false : true}
                  defaultValue={
                    valorFisCons ? valorFisCons.idvalorfiscconstruc : ""
                  }
                  onKeyUp={validarValor}
                  onBlur={validarValor}
                  id="inputCodigo"
                  onClickButton={() => { setMostrarValor(true) }}
                  disabledButton={operacion === 1 ? true : false}
                />
              </div>
              <div className="col-9 m-0 mb-1 p-0 px-2">
                <Input label='Descripción:'
                  ref={txtNumPatente}
                  disabled={true}
                  defaultValue={valorFisCons ? valorFisCons.descripcion : ""}
                  id="inputNumPatente"
                />
              </div>
              <div className="col-3 m-0 mb-1 p-0 px-2">
                <Input label='Porcentaje de Cálculo %'
                  inputClassName="text-end"
                  disabled
                  ref={txtvaloruniconst}
                  value={
                    valorFisCons
                      ? formatMoneda(
                        valorFisCons.porcentajeconstruc
                          .toString()
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                      : ""
                  }
                />
              </div>
              <div className="col-3 m-0 mb-1 p-0 px-2">
                <Input label='Monto Avalú UC.'
                  inputClassName="text-end"
                  disabled={true}
                  ref={txtRitm}
                  value={formatMoneda(
                    totalAvaluo.toString().replace(".", ","),
                    ",",
                    ".",
                    2
                  )}
                />
              </div>
              <div className="col-3 m-0 mb-1 p-0 px-2">
                <Select label='Desde el Año:'
                  ref={cmbdesde}
                  disabled={inmueble && inmueble.idinmueble ? false : true}
                >
                  {anio &&
                    anio.map((a) => (
                      <option key={a.anio} value={a.anio}>
                        {a.anio}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-3 m-0 mb-1 p-0 px-2">
                <Select label='Hasta el Año:'
                  ref={cmbhasta}
                  disabled={inmueble && inmueble.idinmueble ? false : true}
                >
                  {anio &&
                    anio.map((a) => (
                      <option key={a.anio} value={a.anio}>
                        {a.anio}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-3 m-0 mb-1 p-0 px-2">
                <Input label='Total Anual Bs.'
                  inputClassName="text-end"
                  disabled
                  ref={txtmontoanual}
                  id="inputDenoComer"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-3 m-0 mb-1 p-0 px-2">
                <Input label='Total Trimestral Bs.'
                  inputClassName="text-end"
                  disabled
                  ref={txtmontomensual}
                  id="inputDenoComer"
                  onChange={handleInputChange}
                />
              </div>
            </fieldset>
            <footer className="col-12 m-0 mt-2 p-0 d-flex gap-2 align-items-center justify-content-end">
              <PrimaryButton icon='fa-plus'
                disabled={inmueble && inmueble.idinmueble ? false : true}
                onClick={crearDeuda}
              >
                Cargar Deudas
              </PrimaryButton>
              <DangerButton
                disabled={inmueble && inmueble.idinmueble ? false : true}
                onClick={blanquear}
              >
                Cancelar
              </DangerButton>
            </footer>
          </fieldset>
          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center border-azul rounded">
            <legend className="float-none w-auto m-0">Créditos Fiscales</legend>
            <div className="col-11 m-0 p-0">
              <TblContainer2
                container={{
                  height: 170,
                  overflow: "auto",
                }}
              >
                <TblHead2 />
                <tbody>
                  {records2 &&
                    records2.map((item, index) => (
                      <tr
                        style={{
                          padding: "0",
                          cursor: "pointer",
                          background:
                            itemSelect2 === index ? "lightskyblue" : "white",
                        }}
                        onClick={seleccionarFila2(index)}
                      >
                        <td
                          style={{
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {item.numerofactura}
                        </td>
                        <td
                          style={{
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {item.monto
                            ? formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                            : ""}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer2>
            </div>
            <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
              <div className="col-auto m-0 p-0">
                <PrimaryButton icon='fa-plus m-0'
                  onClick={gestionarFact(1)}
                  disabled={activo3}
                />
              </div>
              <div className="col-auto m-0 p-0">
                <DangerButton icon='fa-trash-alt m-0'
                  disabled={activo2}
                  onClick={gestionarFact(3)}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div
          class="tab-pane fade"
          id="deuda-tab-pane"
          role="tabpanel"
          aria-labelledby="deuda-tab"
          tabindex="0"
        >
          <TablaDeudaInmueble
            tabDeuda={deuda}
            idinmueble={idinmu}
            credito={credito && credito > 0 ? credito : 0.0}
            factorcambio={factorCambio}
          />
        </div>
        <div
          class="tab-pane fade"
          id="historico-tab-pane"
          role="tabpanel"
          aria-labelledby="historico-tab"
          tabindex="0"
        >
          <TablaHistoricosInmuebles tabHis={historico} idinmueble={idinmu} />
        </div>
      </div>

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <ModalAgregarAvaluo
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
        idAval={idavaluo}
        idClaseTerr={idClaseTerr}
        operacion={operacion}
        valorPetro={factorCambio}
        dataInmueble={inmueble}
        idinmueble={id}
        render={seleccionaAvaluos}
      />

      <ModalAgregarFactura
        show={mostrarFact}
        operacion={operacionFact}
        onHideCancela={() => {
          setMostrarFact(false);
        }}
        numfac={numfac}
        inmueble={inmueble}
        onHideRender={facturasCredito}
      />

      <CatalogoValorFisCon
        show={mostrarValor}
        onHideCancela={() => {
          setMostrarValor(false);
        }}
        onHideAcepta={updateValor}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <CatalogoInmueble
        show={mostrar2}
        onHideCancelaCatInm={() => {
          setMostrar2(false);
        }}
        onHideAceptaCatInm={catalogoAceptar}
      />
      </div>
    </div>
  );
}

export default TablaAvaluos;
